import type { IQuestionsPageViewProps } from '../QuestionsPageView';
import type { ExpectedDegreeSchemaType } from '../stepsMap';

import { yupResolver } from '@hookform/resolvers/yup';
import { useContext } from 'react';
import { useForm } from 'react-hook-form';

import { QuestionPageContext } from '../QuestionPageProvider';
import { expectedDegreeSchema } from '../stepsMap';

import StudentQuestion from '$/components/blocks/StudentQuestion';
import Container from '$/components/elements/Container';
import SelectAnswerInputQuestion from '$/components/elements/Questions/SelectAnswerInputQuestion';
import { TRACKING_ACTION } from '$/utils/tracking/consts';

const ExpectedDegree = (props: IQuestionsPageViewProps) => {
  const { setCurrentStep, dispatch, state } = useContext(QuestionPageContext);

  const { control, handleSubmit } = useForm<ExpectedDegreeSchemaType>({
    mode: 'onChange',
    resolver: yupResolver(expectedDegreeSchema),
    defaultValues: state,
  });

  const onSubmit = (payload: ExpectedDegreeSchemaType) => {
    dispatch({
      type: 'set',
      payload,
    });
    setCurrentStep('studies');
  };

  return (
    <StudentQuestion noLimitHeight>
      <Container as="form">
        <SelectAnswerInputQuestion
          title={'Welchen Abschluss verfolgst du?'}
          list={props.degrees}
          control={control}
          name={'expectedDegree'}
          onValueSelected={handleSubmit(onSubmit)}
          selectFieldElbAction={TRACKING_ACTION.REGISTRATION.DEGREE}
        />
      </Container>
    </StudentQuestion>
  );
};

export default ExpectedDegree;
